export default function Process() {
  const steps = [
    {
      number: '01',
      title: 'Tiếp Nhận Yêu Cầu',
      description: 'Gọi điện hoặc nhắn tin cho chúng tôi',
      icon: 'ri-phone-line',
      color: 'from-teal-500 to-teal-600',
      image: 'https://public.readdy.ai/ai/img_res/9a2954d786b4730d0897a6b72b41b1bb.jpg'
    },
    {
      number: '02',
      title: 'Khảo Sát & Báo Giá',
      description: 'Nhân viên đến tận nơi đánh giá và báo giá',
      icon: 'ri-file-list-3-line',
      color: 'from-amber-500 to-orange-500',
      image: 'https://readdy.ai/api/search-image?query=Vietnamese%20scrap%20dealer%20worker%20inspecting%20pile%20of%20metal%20iron%20steel%20at%20outdoor%20scrap%20yard%20Vietnam%20realistic%20street%20photo%20natural%20sunlight%20worn%20clothes%20clipboard%20weighing%20scale&width=400&height=500&seq=vn-process-step2-102&orientation=portrait'
    },
    {
      number: '03',
      title: 'Thu Gom Phế Liệu',
      description: 'Đội ngũ chuyên nghiệp thu gom nhanh chóng',
      icon: 'ri-truck-line',
      color: 'from-teal-600 to-teal-700',
      image: 'https://readdy.ai/api/search-image?query=Vietnamese%20workers%20loading%20scrap%20metal%20onto%20old%20truck%20on%20narrow%20alley%20street%20Vietnam%20realistic%20documentary%20photo%20urban%20neighborhood%20worn%20building%20facades%20natural%20daylight&width=400&height=500&seq=vn-process-step3-103&orientation=portrait'
    },
    {
      number: '04',
      title: 'Thanh Toán Ngay',
      description: 'Thanh toán tiền mặt hoặc chuyển khoản ngay',
      icon: 'ri-money-dollar-circle-line',
      color: 'from-yellow-500 to-amber-500',
      image: 'https://readdy.ai/api/search-image?query=Vietnamese%20scrap%20buyer%20handing%20cash%20Vietnamese%20dong%20banknotes%20to%20seller%20outdoor%20scrap%20yard%20Vietnam%20realistic%20street%20photo%20natural%20light%20hands%20exchanging%20money%20worn%20environment&width=400&height=500&seq=vn-process-step4-104&orientation=portrait'
    }
  ];

  return (
    <section id="process" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
            Quy Trình Làm Việc<br />
            Đơn Giản & Nhanh Chóng
          </h2>
        </div>

        {/* Steps Grid */}
        <div className="grid md:grid-cols-4 gap-6">
          {steps.map((step, index) => (
            <div key={index} className="relative group">
              {/* Card */}
              <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
                {/* Image/Icon Area */}
                <div className="relative h-64 bg-gray-100 flex items-center justify-center overflow-hidden">
                  <img
                    src={step.image}
                    alt={step.title}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                  <div className={`absolute top-4 right-4 w-16 h-16 bg-gradient-to-br ${step.color} rounded-2xl flex items-center justify-center shadow-lg`}>
                    <div className="w-16 h-16 flex items-center justify-center">
                      <i className={`${step.icon} text-white text-3xl`}></i>
                    </div>
                  </div>
                </div>

                {/* Info Area */}
                <div className="p-6">
                  <div className="text-gray-300 text-sm font-medium mb-2">{step.number}</div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{step.title}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">{step.description}</p>
                </div>
              </div>

              {/* Arrow Connector */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-32 -right-3 z-10">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-gray-300 text-2xl"></i>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <p className="text-gray-600 text-base mb-6">
            Quy trình đơn giản, nhanh chóng - Hoàn thành trong vòng 2-4 giờ
          </p>
          <a href="tel:0909123456" className="inline-flex items-center gap-3 bg-gray-900 hover:bg-gray-800 text-white px-8 py-4 rounded-full text-sm font-bold transition-all whitespace-nowrap shadow-lg">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-fill text-lg"></i>
            </div>
            BẮT ĐẦU NGAY
          </a>
        </div>
      </div>
    </section>
  );
}